import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetDowntimeDetailReport'
import Component from 'components/Reports/AssetDowntimeDetailReport'

export default createListViewContainer({ actions, selectors: selectors.assetDowntimeDetailReport })(Component)
